import { AppDispatch } from 'store';
import { accountSlice } from '../../reducers/account';

export const logOutAction = () => (dispatch: AppDispatch) => {
	dispatch(accountSlice.actions.logOut());
};
